import ProcessIMG1 from  '../../../assets/images/nas-process-1.png'
import ProcessIMG2 from  '../../../assets/images/nas-process-2.png'
import ProcessIMG3 from  '../../../assets/images/nas-process-3.png'
import ProcessIMG4 from  '../../../assets/images/nas-process-4.png'
import ProcessIMG5 from  '../../../assets/images/nas-process-5.png'
import ProcessMobile1 from '../../../assets/images/itm01.png';
import ProcessMobile2 from '../../../assets/images/itm02.png';
import ProcessMobile3 from '../../../assets/images/itm03.png';
import ProcessMobile4 from '../../../assets/images/itm04.png';
import ProcessMobile5 from '../../../assets/images/itm05.png';
import ProcessMobile6 from '../../../assets/images/itm05.png';

import { Service } from './types';

export const services: Service[] = [
  {
    id: 1,
    icon: ProcessMobile1,
    mobileIcon: ProcessMobile1,
    alt: 'DevSecOps Audit',
    title: 'Audit de sécurité',
    description: 'Évaluation complète de votre posture de sécurité.',
    link: '/#',
    features: [
      { text: '' },
      { text: "Analyse des vulnérabilités." },
      { text: 'Évaluation des processus.' },
      { text: 'Recommandations prioritaires.' },
    ],
  },
  {
    id: 2,
    icon: ProcessMobile2,
    mobileIcon: ProcessMobile2,
    alt: 'Security Strategy Icon',
    title: 'Stratégie DevSecOps',
    description: 'Définition d\'une stratégie de sécurité intégrée.',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Politique de sécurité.' },
      { text: 'Processus automatisés.' },
      { text: 'Formation des équipes.' },
    ],
  },
  {
    id: 3,
    icon: ProcessMobile3,
    mobileIcon: ProcessMobile3,
    alt: 'Security Pipeline Icon',
    title: 'Pipeline sécurisé',
    description: 'Intégration de la sécurité dans vos pipelines CI/CD.',
    link: '/#',
    features: [
      { text: '' },
      { text: "Tests de sécurité automatisés." },
      { text: 'Scan de vulnérabilités' },
      { text: 'Gates de sécurité.' }
    ],
  },
  {
    id: 4,
    icon: ProcessMobile4,
    mobileIcon: ProcessMobile4,
    alt: 'Monitoring Icon',
    title: 'Monitoring et alertes',
    description: 'Surveillance continue de la sécurité en production.',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Détection d\'intrusions.' },
      { text: 'Alertes en temps réel.' },
      { text: 'Réponse aux incidents.' },

    ],
  },
  {
    id: 5,
    icon: ProcessMobile5,
    mobileIcon: ProcessMobile5,
    alt: 'Compliance Icon',
    title: 'Conformité continue',
    description: 'Maintien de la conformité réglementaire automatisée.',
    link: '/training',
    features: [
      { text: '' },
      { text: 'Audits automatiques.' },
      { text: 'Rapports de conformité.' },
      { text: 'Mise à jour des politiques.' },
    ],
  },
  {
    id: 6,
    icon: ProcessMobile6,
    mobileIcon: ProcessMobile6,
    alt: 'Security Enhancement Icon',
    title: 'Amélioration continue',
    description: 'Évolution constante de votre posture de sécurité.',
    link: '/#',
    features: [
      { text: '' },
      { text: 'Veille sécuritaire.' },
      { text: 'Optimisation des processus.' },
      { text: 'Formation continue.' },
    ],
  },
];